import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-masques',
  templateUrl: './tennis.component.html',
  styleUrls: ['./tennis.component.css']
})
export class TennisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
